import { useEffect, useState, useContext } from 'react';
import { Container, Typography, Stack, Box, CircularProgress } from '@mui/material';
import { CabangAbsenForm } from '../../../sections/cabang/absen';
import { axiosPrivate } from '../../../common/axiosPrivate';
import AuthContext from '../../../context/authContext';

const CabangAddAbsenPage = ({handleCloseModal, handleUpdateTable}) => {
  const { user } = useContext(AuthContext);
  const [dropDown, setDropDown] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setPageLoading(true);

    const fetchDropdown = async () => {
      try {
        let response;
        if (user?.role === 'area' && user?.kantorList?.length > 0) {
          // Multi kantor: kirim sebagai query params, contoh ?kantorList=KTR001,KTR002
          response = await axiosPrivate.get('pegawai-absen/dropdown/list', {
            params: {
              kantorList: user.kantorList.join(','),
              role: user.role
            }
          });
        } else if (user?.kantor) {
          // Single kantor (default)
          response = await axiosPrivate.get(`pegawai-absen/dropdown/list/${user.kantor}`);
        }
        setDropDown(response?.data || []);
      } catch (error) {
        console.log(error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchDropdown();
  }, [user?.kantor, user?.role, user?.kantorList]);

  return (
    <>
      {pageLoading ? (
        <Box
          sx={{
            flexGrow: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          width={"100%"}
        >
          <CircularProgress />
        </Box>) : (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Tambah Absen
            </Typography>
          </Stack>
          <CabangAbsenForm
            dropDown={dropDown}
            handleCloseModal={handleCloseModal}
            handleUpdateTable={handleUpdateTable}
          />
        </Container>
      )}
    </>
  );
}
  
export default CabangAddAbsenPage;
